import { useState } from "react";
import { feedbackStaffRequest } from "@/lib/feedbackApi";
export function FeedbackInvoiceOption({
  caseId,
  invoiceIds,
  checked,
  onChange,
  disabled,
}: {
  caseId: string;
  invoiceIds: string[];
  checked: boolean;
  onChange: (v: boolean) => void;
  disabled: boolean;
}) {
  const [html, setHtml] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const preview = async () => {
    setBusy(true);
    setError("");
    try {
      const data = await feedbackStaffRequest({ action: "preview", caseId, invoiceIds });
      setHtml(data.html);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Aperçu indisponible.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-3 rounded-lg border border-indigo-200 bg-indigo-50 p-3 text-sm">
      <label className="flex items-center gap-2 font-medium text-indigo-900">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        Ajouter l’invitation à donner un avis dans cet email de facture
      </label>
      <p className="mt-1 text-xs text-indigo-700">
        Événement Smile passé et facture finale active uniquement. Une invitation par dossier.
      </p>
      <button
        type="button"
        disabled={busy || disabled}
        onClick={preview}
        className="mt-2 text-xs font-medium text-indigo-800 underline"
      >
        {busy ? "Préparation…" : "Voir le bloc ajouté à l’email"}
      </button>
      {error && (
        <p role="alert" className="mt-2 text-xs text-red-700">
          {error}
        </p>
      )}
      {html && (
        <div className="mt-3">
          <iframe
            title="Bloc d’avis ajouté à l’email de facture"
            sandbox=""
            srcDoc={html}
            className="h-[390px] w-full rounded-lg border bg-white"
          />
          <button type="button" onClick={() => setHtml("")} className="mt-1 text-xs underline">
            Fermer l’aperçu
          </button>
        </div>
      )}
    </div>
  );
}
